import {
  FormHelperText,
  InputLabel,
  TextField as MuiTextField,
  type TextFieldProps,
} from '@mui/material';
import { cn } from 'cn';

export const TextField = (props: TextFieldProps) => {
  return (
    <div className={cn('relative', props.className)}>
      <InputLabel
        className={cn('text-sm', { 'text-mui-error-red': props.error })}
      >
        {props.title}
      </InputLabel>
      <MuiTextField
        {...props}
        autoComplete="off"
        error={Boolean(props.error)}
        placeholder={props.placeholder}
        size="small"
        value={props.value}
        variant="outlined"
        fullWidth
        onChange={props.onChange}
      />
      {props.error ? (
        <div className="flex w-full justify-end">
          <FormHelperText className="text-mui-error-red absolute">
            {props.error}
          </FormHelperText>
        </div>
      ) : null}
    </div>
  );
};
